import { db } from "./firebase";
import { doCreateUserWithEmailAndPassword } from "./auth"

// export const getAllTags = async () => {
//   const snapshot = await db.ref('/cat_tags').once('value')

//   const data = snapshot.val()

//   const cat_tags = Object.keys(data).map(key => {
//     return data[key]
//   })

//   let updates = {}
//   cat_tags.map(cat_tag => {
//     Object.entries(cat_tag).map(tag => {
//       updates[`tags/${tag[0]}/assigned`] = true
//     })
//   })

//   console.log(updates)

//   await db.ref().update(updates)
// }


export function generateRandomId(){
    let randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    let uniqid = randLetter + Date.now();
     return uniqid ;
}
// User API
export const doCreateUser = async (name: string, email: string, password: string) => {
        const credential = await doCreateUserWithEmailAndPassword(email,password)
        return db.ref(`users/${credential.user.uid}`).set({
          id : credential.user.uid,
          email,
          name,
          isAdmin: true,
          photo : "https://winkeyecare.com/wp-content/uploads/2013/03/Empty-Profile-Picture-450x450.jpg"
      })
}
export const getUserById = (id: string) => db.ref("users/" + id).once("value");

export const getUserGifsIds = (id: string) => db.ref("user_gifs/" + id).once("value");

export const doDeleteUser = (id: string) =>
  db.ref(`users/${id}`).update({
      deleteDate: new Date(),
      deleted: true
  });

export const doActivateUser = (id: string) =>
  db.ref(`users/${id}`).update({
      deleteDate: "",
      deleted: false
  });

export const doGetUserById  = (id) => db.ref("users/" + id).once("value");
export const onceGetUsers = () => db.ref("users").once("value");




// Tags API
export const doCreateTag = (text: string) =>
    { const id = generateRandomId()
      return db.ref(`tags/${id}`).set({
          id,
          text
        });
    }
export const doUpdateTag = (id: string, text: string, categories : any[]) =>
  db.ref(`tags/${id}`).update({
    text,
    categories
  });
export const doDeleteTag = (id: string) => db.ref(`tags/${id}`).remove();

export const onceGetTags = () => db.ref("tags").once("value");





// GIFs API
export const onceGetGifs = () => db.ref("gifs").once("value");

export const doDeleteGif = (id: string) =>
  db.ref(`gifs/${id}`).remove();

export const doUpdateGif = (id: string, title: string, description:string, tags : any[]) =>
  db.ref(`gifs/${id}`).update({
    title,
    description,
    tags
  });
export const getGifById = (id: string) => db.ref("gifs/" + id).once("value");



// Category API

export const doDeleteCategory = (id: string) =>
  db.ref(`categories/${id}`).remove();

export const onceGetCategories = () => db.ref("categories").orderByChild('priority').once("value");

export const getCategoryById = (id) => db.ref("categories/" + id).once("value");

export const doCreateCategoryWithTags = (id: string ,name: string, priority: any, tags : any[]) => {
    let updates = {}
    updates[`categories/${id}`] = {id, name, priority, tags}
    tags.map((tag) => {
      updates[`cat_tags/${id}/${tag.id}`] = tag.text
      updates[`tags/${tag.id}/categories`] = tag.categories ?
      [ ...tag.categories , {id: id , name: name , priority: priority,  tags : tags} ]
      : [ {id: id , name: name , priority: priority, tags : tags} ]
    });
    return db.ref().update(updates)
}


export const doAffectTagToCategory = async (tag, categories, relatedCategories) => {
  let updates = {}
  
  updates[`tags/${tag.id}/assigned`] = true

  relatedCategories.map(cat => {
    updates[`cat_tags/${cat.id}/${tag.id}`] = tag.text
  })

  let cat_ids = []
  let cat_tags_promises = []
  relatedCategories.map(cat => {
    cat_ids.push(cat.id)
    cat_tags_promises.push(
      db.ref(`categories/${cat.id}/tags`).once('value')
    )
  })

  const tags_res = await Promise.all(cat_tags_promises)

  tags_res.map((tag_res, index) => {
    let previousTags = tag_res.val()
    let newTags = previousTags
    newTags.push(tag)
    updates[`categories/${cat_ids[index]}/tags`] = newTags
  })

  return db.ref().update(updates)
}


 export const doUpdateCategoryWithTags = async (category: any, name : any ,tags : any[] , priority) => {
  let updates = {}

  let strippedTags = tags.map(tag => {
    let tmp = tag
    delete tmp.categories
    return tmp
  })

  updates[`categories/${category.id}`] = {
    id: category.id,
    name,
    tags: strippedTags,
    priority
  }

  await db.ref(`cat_tags/${category.id}`).remove()

  tags.map((tag)=>{
    updates[`cat_tags/${category.id}/${tag.id}`] = tag.text
  })

  return db.ref().update(updates)
}


export const doGetGifsByCategory = (categorie : any)  => {
  const api = "https://search.tgif.placeholder.tn/elasticsearch/gifs/_search"
  return fetch (api, {
        method: 'POST',
        headers: new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
          query: {
            nested: {
              path: "tags",
              query: {
                bool: {
                  should: getCategoryTags(categorie)
                }
              }
            }
          }
        })
      })
}

const getCategoryTags = (category) => {
    //cat
    const should = category.tags.map(tag => {
        const tags = {}
        tags['tags.text'] = tag.text
        return {
            match: tags
        }
    })

    return should
}



// WEBPACK FOOTER //
// ./src/firebase/db.ts